module.exports = __webpack_public_path__ + "media/images/marisol/marisol2-d61b0cd3148ef3e203d3d03e0a0a728e.png";